import Helpers from '../../common/helpers/Helpers';
import Constants from '../../common/constants/Constants';

export const getInstrumentsList = () => {
  return Helpers.get(Constants.INSTRUMENTS_URL);
};
